<template>
	<div class="content-real-time">
		<div class="header-order-tracking" v-bind:style="{backgroundColor : color_botones }">
			<div class="force-close">
				<i class="fas fa-chevron-left" @click="backToManagment()" v-if="formRestaurant"></i>
			</div>
			<h4>Detalle orden</h4>
			<h5>Número del pedido: {{ id_order }}</h5>
		</div>
		<div class="body-real-time">

			<div class="first-task">
				<div class="status-task">
					<i class="fas fa-check"></i>
					<i class="fas fa-times"></i>
				</div>
				<div class="figure">
					
				</div>
				<div class="content-task">
					<label for=""><i class="far fa-calendar-check"></i> Orden creada</label><br>
					<h6>{{ horaNueva }}</h6>
				</div>
			</div>

			<div class="single-task" v-if="status">
				<div class="status-task">
					<i class="fas fa-check"></i>
					<i class="far fa-clock"></i>
					<i class="fas fa-times"></i>
				</div>
				<div class="figure">
					
				</div>
				<div class="content-task">
					<label for=""><i class="far fa-calendar-check"></i> Orden confirmada</label><br>
					<h6>{{ horaCreada }}</h6>
				</div>
			</div>

			<div class="single-task">
				<div class="status-task">
					<i class="fas fa-check"></i>
					<i class="far fa-clock"></i>
				</div>
				<div class="figure">
					
				</div>
				<div class="content-task">
					<label for=""><i class="fas fa-utensils"></i> En preparación</label><br>
					<h6 id="preparacion">{{ nuevaHora }}</h6>
				</div>
			</div>

			<div class="single-task" v-if="mesa == 0">
				<div class="status-task">
					<i class="fas fa-check"></i>
					<i class="far fa-clock"></i>
				</div>
				<div class="figure">
					
				</div>
				<div class="content-task">
					<label for=""><i class="fas fa-biking"></i> Orden enviada</label><br>
					<h6 id="enviado">{{ horaEnviadaLista }}</h6>
				</div>
			</div>

			<div class="single-task" v-if="mesa > 0">
				<div class="status-task">
					<i class="fas fa-check"></i>
					<i class="far fa-clock"></i>
				</div>
				<div class="figure">
					
				</div>
				<div class="content-task">
					<label for=""><i class="fas fa-biking"></i>Orden Lista</label><br>
					<h6 id="enviado">{{ horaEnviadaLista }}</h6>
				</div>
			</div>

			<div class="single-task">
				<div class="status-task">
					<i class="fas fa-check"></i>
					<i class="far fa-clock"></i>
				</div>
				<div class="figure">
					
				</div>
				<div class="content-task">
					<label for=""><i class="fas fa-people-carry"></i> Orden entregada</label><br>
					<h6>{{ horaEntregada }}</h6>
				</div>
			</div>
		</div>
		<div class="container-back-to-store" v-show="confirmar_order">
			<div class="btn-back-to-store" @click="back()" v-bind:style="{backgroundColor : color_botones }">
				<i class="fas fa-check"></i>
				<h4>Confirmar pedido</h4>
			</div>
		</div>
		<div class="container-back-to-store" v-show="order_finish">
			<div class="btn-back-to-store" @click="Backtohome()" v-bind:style="{backgroundColor : color_botones }">
				<i class="fas fa-home"></i>
				<h4>Volver a la tienda</h4>
			</div>
		</div>
		<div class="info-order" v-if="show_ref">
			<i class="fas fa-info"></i>
			<h4>Tu orden se confirmará en breve</h4>
		</div>
		<div class="order-out" v-if="order_explote">
			<div class="canceled-info">
				<i class="fas fa-exclamation-triangle"></i>
				<h4>Se ha cancelado tu orden</h4>
				<button @click="Backtohome()">Volver a la tienda</button>
			</div>
		</div>
		<div class="order-out" v-if="exit_component">
			<div class="canceled-info2">
				<i class="fas fa-exclamation-triangle"></i>
				<h4>¿Está seguro que desea salir?</h4>
				<div class="exit-options">
					<button @click="forceClose()">Si</button>
					<button @click="exit_component = false">No</button>
				</div>
			</div>
		</div>
	</div>
</template>

<style type="text/css" scoped>

		@import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');

		*{
			padding: 0;
			margin: 0;
			box-sizing: border-box;
		}

		*:focus{
			outline: none;
			box-shadow: none;
		}

		.exit-options{
			width: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
		}

		.canceled-info2{
			background: #fff;
			width: 80%;
			margin: 0 auto;
			padding-top: 20px;
			text-align: center;
			display: block;
			border-radius: 10px;
		}

		.canceled-info2 i{
			color: #E43A3A;
			font-size: 29px;
		}

		.canceled-info2 h4{
			font-family: 'Poppins', sans-serif;
			font-size: 17px;
			font-weight: 500;
			padding-top: 14px;
		}

		.canceled-info2 button{
			width: 50%;
			border-bottom: none;
			border-left: none;
			border-right: none;
			background: transparent;
			border-top: 1px solid #E8E8E8;
			margin-top: 10px;
			padding-top: 15px;
			padding-bottom: 15px;
			font-family: 'Poppins', sans-serif;
		}

		.force-close{
			width: 100%;
			text-align: left;
			padding-top: 15px;
		}

		.force-close i{
			color: #fff;
			font-size: 19px;
			cursor: pointer;
		}

		.order-out{
			width: 100%;
			height: 100vh;
			position: absolute;
			top: 0;
			background-color: rgba(0, 0, 0, .6);
			display: flex;
			justify-content: center;
			align-items: center;
		}

		.canceled-info{
			background: #fff;
			width: 80%;
			margin: 0 auto;
			padding-top: 20px;
			text-align: center;
			display: block;
			border-radius: 10px;
		}

		.canceled-info i{
			color: #E43A3A;
			font-size: 29px;
		}

		.canceled-info h4{
			font-family: 'Poppins', sans-serif;
			font-size: 17px;
			font-weight: 500;
			padding-top: 14px;
		}

		.canceled-info button{
			width: 100%;
			border-bottom: none;
			border-left: none;
			border-right: none;
			background: transparent;
			border-top: 1px solid #E8E8E8;
			margin-top: 10px;
			padding-top: 15px;
			padding-bottom: 15px;
			font-family: 'Poppins', sans-serif;
		}

		.info-order{
			width: 85%;
			margin: 0 auto;
			border:  1px solid #dddddd;
			border-radius: 6px;
			padding: 8px 10px;
			display: flex;
			justify-content: center;
		}

		.info-order h4{
			font-family: 'Poppins', sans-serif;
			font-size: 15px;
		}

		.info-order i{
			margin-right: 5px;
		}

		.first-task{
			width: 100%;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			padding-bottom: 15px;
		}

		.first-task .figure{
			background-color: #2FD473;
		}

		.first-task .content-task i{
			color: #2FD473;
		}

		.canceled{
			background-color: #DD2525 !important;
		}

		.canceled-order{
			color: #DD2525 !important;
		}

		.enabled{
			background-color: #D2D2D2 !important;
		}

		.enabled-color{
			color: #D2D2D2 !important;
		}

		.message-order{
			width: 100%;
			height: 100vh;
			position: absolute;
			top: 0;
			background: #fff;
			z-index: 2;
			display: block;
			padding-top: 45%;
		}

		.message-order img{
			width: 40%;
			animation: upto .9s ease-in-out;
		}

		.message-order h4{
			padding-top: 22px;
			font-size: 21px;
			font-weight: 500;
			color: #4D4D4D;
			font-family: 'Poppins', sans-serif;
			animation: upto .9s ease-in-out;
			animation-delay: .3s;
		}

		.message-order button{
			padding: 12px 28px;
			border: none;
			border-radius: 8px;
			color: #fff;
			font-family: 'Poppins', sans-serif;
			font-size:  17px;
			margin-top: 28px;
			animation: upto .9s ease-in-out;
			animation-delay: .3s;
		}

		@keyframes upto {
			from{
				opacity: 0;
				transform: translateY(120px);
			}
			to{
				opacity: 1;
				transform: translateY(0px);	
			}
		}	

		.content-real-time{
			width: 100%;
			height: auto;
		}

		.header-order-tracking{
			width: 100%;
			height: 20vh;
			padding: 0px 15px 0px 25px;
			text-align: left;
		}

		.header-order-tracking h4{
			margin-bottom: 0 !important;
			font-family: 'Poppins';
			color: #fff;
			font-weight: 500;
		}

		.header-order-tracking h5{
			margin-bottom: 0 !important;
			font-family: 'Poppins';
			color: #fff;
			font-size: 16px;
			font-weight: 500;
		}

		.body-real-time{
			width: 100%;
			background: #fff;
			border-top-left-radius: 20px;
			box-shadow: 0px -12px 8px 0px rgba(77,77,77,.15);
			margin-top: -20px;
			z-index: 1;
			padding: 45px 15px 15px 15px;
		}

		.single-task{
			width: 100%;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			padding-bottom: 15px;
		}

		.status-task{
			width: 60px;
			height: 60px;
			border-radius: 10px;
			background: #2FD473;
			display: flex;
			justify-content: center;
			align-items: center;
		}

		.status-task i {
			color: #fff;
		}

		.figure{
			width: 35px;
			height: 85px;
			background: #5D5AF1;
			clip-path: polygon(81% 0, 100% 0, 100% 34%, 100% 58%, 100% 100%, 83% 100%, 83% 78%, 63% 51%, 81% 22%);
		}

		.content-task{
			width: 80%;
			height: 85px;
			border-top-right-radius: 15px;
			border-bottom-right-radius: 15px;
			box-shadow: 3px 0px 12px 0px rgba(235,235,235,.4);
			padding: 15px 10px 5px 10px;
			text-align: left;
		}

		.content-task label{
			font-size: 18px;
			font-weight: 500;
			font-family: 'Poppins';
			color: #737373;
		}


		.content-task h6{
			margin-bottom: 0 !important;
			font-size: 14px;
			font-family: 'Poppins';
			font-weight: 400;
			color: #9e9e9e;
		}

		.container-back-to-store{
			width: 100%;
			padding: 20px 15px 0px 15px;
			display: flex;
			justify-content: flex-end;
		}

		.btn-back-to-store{
			width: 78%;
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 18px 15px 18px 15px;
			border-radius: 5px;
			box-shadow: 3px 0px 12px 0px rgba(235,235,235,.4);
		}

		.btn-back-to-store h4{
			color: #fff;
			margin-bottom: 0 !important;
			font-family: 'Poppins';
			font-size: 17px;
			font-weight: 500;
		}

		.btn-back-to-store i{
			color: #fff;
			font-size: 17px;
		}

		.body-real-time .single-task:nth-child(1) .status-task{
			background: #CBCBCB;
		}

		.body-real-time .single-task:nth-child(1) .figure{
			background: #CBCBCB;
		}

		.body-real-time .single-task:nth-child(1) .content-task i{
			color: #CBCBCB;
		}

		.body-real-time .single-task:nth-child(2) .status-task{
			background: #CBCBCB;
		}

		.body-real-time .single-task:nth-child(2) .figure{
			background: #CBCBCB;
		}

		.body-real-time .single-task:nth-child(2) .content-task i{
			color: #CBCBCB;
		}

		.body-real-time .single-task:nth-child(3) .status-task{
			background: #CBCBCB;
		}

		.body-real-time .single-task:nth-child(3) .figure{
			background: #CBCBCB;
		}

		.body-real-time .single-task:nth-child(3) .content-task i{
			color: #CBCBCB;
		}

		.body-real-time .single-task:nth-child(4) .status-task{
			background: #CBCBCB;
		}

		.body-real-time .single-task:nth-child(4) .figure{
			background: #CBCBCB;
		}

		.body-real-time .single-task:nth-child(4) .content-task i{
			color: #CBCBCB;
		}

		.animation{
			animation: mostrar 2s linear infinite;
		}

		.succes{
			background: #2FD473 !important;
			transition: .7s ease-in-out;
		}

		.color-succes{
			color: #2FD473 !important;
		}

		.pt{
			padding-top: 25px;
		}

		@keyframes mostrar {
		    0%{
		      box-shadow: 0 0 0 0 rgba(47, 212, 115,.8), 0 0 0 0 rgba(47, 212, 115,.8);
		    }
		    40%{
		      box-shadow: 0 0 0 10px rgba(47, 212, 115,0), 0 0 0 0 rgba(47, 212, 115,.8);
		    }
		    80%{
		      box-shadow: 0 0 0 10px rgba(47, 212, 115,0), 0 0 0 10px rgba(47, 212, 115,0);
		    }
		    100%{
		      box-shadow: 0 0 0 0 rgba(47, 212, 115,0), 0 0 0 10px rgba(47, 212, 115,0);
		    }
 		}
</style>

<script>
	import Vue from 'vue'
    import Vuesax from 'vuesax'
    import axios from 'axios';
    import $ from 'jquery';
    import { osName } from 'mobile-device-detect';
    import moment from 'moment';
    import push from 'push.js';
	export default{
		props:['formRestaurant'],
		data(){
			return{
				exit_component: false,
				id_companie: localStorage.getItem('companie_id'),
				order_explote: false,
				show_ref: true,
				status: false,
				horaNueva: "--:--",
				color_botones: localStorage.getItem('color_licencia'),
				mesa: localStorage.getItem('mesa') ? localStorage.getItem('mesa') : 0,
				horaCreada:"--:--",
				nuevaHora: "--:--",
				id_tracking: localStorage.getItem(`id_estado_order_${localStorage.getItem('companie_id')}`),
				horaEnviadaLista:"--:--",
				horaEntregada:"--:--",
				socket: "",
				orderTracking:[],
				socketInfo:{
					 id_type_profile:87,
					 id_point:localStorage.getItem('id_punto'),
					 id_type_status: "",
					 id_order:localStorage.getItem('id_order')
					},
				id_order:localStorage.getItem('id_order'),
				id_point:localStorage.getItem('id_punto'),
				confirmar_order: false,
				order_finish: false
			}
		},
		methods:{
			backToManagment(){
				this.$emit('closeTracking',false);
			},
			Backtohome(){
				location.reload();
			},
			confirmOrder(){
				//ocultamos el icono del reloj y mostramos el check
				$(".body-real-time .single-task:nth-child(1) .status-task i:nth-child(1)").show();
				$(".body-real-time .single-task:nth-child(1) .status-task i:nth-child(2)").hide();
				//actualizamos los colores a success cuando se llama al metodo
				$(".body-real-time .single-task:nth-child(1) .status-task").addClass("succes");
				$(".body-real-time .single-task:nth-child(1) .figure").addClass("succes");
				$(".body-real-time .single-task:nth-child(1) .content-task i").addClass("color-succes");
				//añadimos la clase de waves
				//$(".body-real-time .single-task:nth-child(1) .status-task").addClass("animation");
			},
			orderSending(){
				$(".body-real-time .first-task .status-task").removeClass("animation");
				$(".body-real-time .single-task:nth-child(2) .status-task").removeClass("animation");
				$(".body-real-time .single-task:nth-child(3) .status-task").addClass("animation");
				//ocultamos el icono del reloj y mostramos el check
				$(".body-real-time .single-task:nth-child(3) .status-task i:nth-child(1)").show();
				$(".body-real-time .single-task:nth-child(3) .status-task i:nth-child(2)").hide();
				//actualizamos los colores a success cuando se llama al metodo
				$(".body-real-time .single-task:nth-child(3) .status-task").addClass("succes");
				$(".body-real-time .single-task:nth-child(3) .figure").addClass("succes");
				$(".body-real-time .single-task:nth-child(3) .content-task i").addClass("color-succes");
			},
			preparingOrder(){
				$(".body-real-time .first-task .status-task").removeClass("animation");
				$(".body-real-time .single-task:nth-child(2) .status-task").addClass("animation");
				//ocultamos el icono del reloj y mostramos el check
				$(".body-real-time .single-task:nth-child(2) .status-task i:nth-child(1)").show();
				$(".body-real-time .single-task:nth-child(2) .status-task i:nth-child(2)").hide();
				//actualizamos los colores a success cuando se llama al metodo
				$(".body-real-time .single-task:nth-child(2) .status-task").addClass("succes");
				$(".body-real-time .single-task:nth-child(2) .figure").addClass("succes");
				$(".body-real-time .single-task:nth-child(2) .content-task i").addClass("color-succes");
			},
			recibedOrder(){
				$(".body-real-time .first-task .status-task").removeClass("animation");
				$(".body-real-time .single-task:nth-child(2) .status-task").removeClass("animation");
				$(".body-real-time .single-task:nth-child(3) .status-task").removeClass("animation");
				$(".body-real-time .single-task:nth-child(4) .status-task").addClass("animation");
				//ocultamos el icono del reloj y mostramos el check
				$(".body-real-time .single-task:nth-child(4) .status-task i:nth-child(1)").show();
				$(".body-real-time .single-task:nth-child(4) .status-task i:nth-child(2)").hide();
				//actualizamos los colores a success cuando se llama al metodo
				$(".body-real-time .single-task:nth-child(4) .status-task").addClass("succes");
				$(".body-real-time .single-task:nth-child(4) .figure").addClass("succes");
				$(".body-real-time .single-task:nth-child(4) .content-task i").addClass("color-succes");
			},
			readyOrder(){
				$(".body-real-time .first-task .status-task").removeClass("animation");
				$(".body-real-time .single-task:nth-child(2) .status-task").removeClass("animation");
				$(".body-real-time .single-task:nth-child(3) .status-task").addClass("animation");
				//ocultamos el icono del reloj y mostramos el check
				$(".body-real-time .single-task:nth-child(3) .status-task i:nth-child(1)").show();
				$(".body-real-time .single-task:nth-child(3) .status-task i:nth-child(2)").hide();
				//actualizamos los colores a success cuando se llama al metodo
				$(".body-real-time .single-task:nth-child(3) .status-task").addClass("succes");
				$(".body-real-time .single-task:nth-child(3) .figure").addClass("succes");
				$(".body-real-time .single-task:nth-child(3) .content-task i").addClass("color-succes");
			},
			hideClock(){				
				$(".body-real-time .single-task:nth-child(1) .status-task i:nth-child(1)").hide();
				$(".body-real-time .single-task:nth-child(2) .status-task i:nth-child(1)").hide();
				$(".body-real-time .single-task:nth-child(3) .status-task i:nth-child(1)").hide();
				$(".body-real-time .single-task:nth-child(4) .status-task i:nth-child(1)").hide();
			},
			orderCanceled(){
				//ocultamos los iconos en el primer evento y mostramos la X
				$(".body-real-time .first-task .status-task i:nth-child(1)").hide();
				$(".body-real-time .first-task .status-task i:nth-child(2)").show();
				//Cambiamos el color y el texto del primer evento	
				$(".body-real-time .first-task .status-task").addClass("canceled");
				$(".body-real-time .first-task .figure").addClass("canceled");
				$(".body-real-time .first-task .content-task i").addClass("canceled-order");
				$(".body-real-time .first-task .content-task label").html("Orden cancelada");
				//definimos los eventos para los demas eventos como nulas
				$(".body-real-time .single-task:nth-child(2) .status-task").addClass("enabled");
				$(".body-real-time .single-task:nth-child(2) .figure").addClass("enabled");
				$(".body-real-time .single-task:nth-child(2) .content-task i").addClass("enabled-color");
				$(".body-real-time .single-task:nth-child(3) .status-task").addClass("enabled");
				$(".body-real-time .single-task:nth-child(3) .figure").addClass("enabled");
				$(".body-real-time .single-task:nth-child(3) .content-task i").addClass("enabled-color");
				$(".body-real-time .single-task:nth-child(4) .status-task").addClass("enabled");
				$(".body-real-time .single-task:nth-child(4) .figure").addClass("enabled");
				$(".body-real-time .single-task:nth-child(4) .content-task i").addClass("enabled-color");
			},
			back(){
				var self = this;
				this.emitSocketInsert(this.id_order,96,true);
				self.confirmar_order = false;
				if (this.$route.params.mesa > 0) {
				 localStorage.setItem(`id_estado_order_${localStorage.getItem('companie_id')}_${this.$route.params.mesa}`,96);
				}else{
				 localStorage.setItem(`id_estado_order_${localStorage.getItem('companie_id')}`,96);
				}
				localStorage.removeItem('id_order');
                localStorage.removeItem('id_punto');
                localStorage.removeItem('mesa');
				  	var d = new Date();
					var menor = "";
					if(d.getMinutes() < 10){
					  menor = "0" + d.getMinutes();
					}else{
					  menor = d.getMinutes();
					}
				    self.horaEntregada = d.getHours() + ":" + menor;
                    //self.confirmOrder()
					self.preparingOrder()
					self.orderSending()
					self.recibedOrder()
					self.order_finish = true;
			},
			reload(){
				location.reload();
			},
			forceClose(){
				if (this.$route.params.mesa > 0) {
				 localStorage.setItem(`id_estado_order_${localStorage.getItem('companie_id')}_${this.$route.params.mesa}`,96);
				}else{
				 localStorage.setItem(`id_estado_order_${localStorage.getItem('companie_id')}`,96);
				}
				localStorage.removeItem('id_order');
                localStorage.removeItem('id_punto');
                localStorage.removeItem('mesa');
                location.reload();
			},
			emitSocketTable(id_point){   
		      var self = this;
		      console.log(id_point)
		      this.socket.emit("setup seguimiento",{id_point:id_point});
		    },  
			getOrderTracking(id_order,status=false){
				this.orderTracking=[]
				var self =this;
				axios.get('https://back.vinapp.co/api/get-order-tracking/'+id_order) 
			    .then(res => {    
			       this.orderTracking=res.data
			       if (status) {
				       	self.socket.emit('setup room',self.socketInfo);
				        self.socket.emit("setup seguimiento",self.socketInfo);
			            console.log('mira'+ self.orderTracking.length)
		            	if(self.orderTracking.length==0)self.emitSocketInsert(self.id_order,91,false);
		                if(self.orderTracking.length>0){
		                	self.socket.emit("send tracking",self.socketInfo);
		                	self.show_ref = true;
		            	} 
			       }
			        
		           this.orderTracking.forEach((detalle)=>{
			       	   if (detalle.id_type_status==91){
				       	   	self.horaCreada=detalle.created_at;
							let hora = self.horaCreada.split(" ")[1].substr(0,5);
							self.horaCreada = hora;
					   	}
					   	if (detalle.id_type_status==92){
				       	   	self.nuevaHora=detalle.created_at;
							let hora = self.nuevaHora.split(" ")[1].substr(0,5);
							self.nuevaHora = hora;
							self.preparingOrder();
							this.show_ref = false;
					   	}

					   	if (detalle.id_type_status==95 || detalle.id_type_status==97) {
                            self.horaEnviadaLista=detalle.created_at;
							let hora = self.horaEnviadaLista.split(" ")[1].substr(0,5);
							self.horaEnviadaLista = hora;
							self.preparingOrder();
							self.orderSending();
							this.confirmar_order = true;
					   	}
					   	if (detalle.id_type_status==96) {
					   		self.horaEntregada=detalle.created_at;
							let hora = self.horaEntregada.split(" ")[1].substr(0,5);
							self.horaEntregada = hora;
							self.preparingOrder();
							self.orderSending();
							self.recibedOrder();
							localStorage.removeItem('id_order');
		                    localStorage.removeItem('id_punto');
		                    localStorage.removeItem('mesa');
							this.order_finish = true;
							location.reload();
					   	}
			       })
			    })
			    .catch(err => {
			        console.log(err);      
			    });
			},
			emitSocketInsert(id_order,id_type_status,status=true){
				let self=this;
                this.socket.emit("insert order tracking",{id_order : id_order,id_type_status:id_type_status});
                if(status)this.socket.emit("get order tracking",{id_order : id_order,id_type_status:id_type_status,id_point:self.id_point});
			},
			showNotification(title, message, url_image = null){
				url_image = url_image != null ? url_image : "https://info.vinapp.co/wp-content/uploads/2021/04/LOGO_VINAPP_Mesa_de_trabajo_1-removebg-preview-1-1.png";
				push.create(title,{
		          body: message,
		          icon: url_image,
		          //timeout: time,
		          onClick: function(event) {
		            window.focus();
		            this.close()
		          }
		        })
			},
			setupSocket() {
				var self = this; 
		            self.socket.on("send tracking", (data)=> {
						//self.horaCreada=data.updated_time.date
						console.log(data)
						let data_json =data
						if (data_json.data.id_type_status==92){
							//self.confirmOrder()
							self.preparingOrder();
							this.show_ref = false;
						} 
						
						if (data_json.data.id_type_status==95 || data_json.data.id_type_status==97 ){
							//self.confirmOrder();
							self.preparingOrder();
							self.orderSending();
							this.confirmar_order = true;
						}
						if (data_json.data.id_type_status==96){
							//self.confirmOrder();
							self.preparingOrder();
							self.orderSending();
							self.recibedOrder();
							localStorage.removeItem('id_order');
		                    localStorage.removeItem('id_punto');
		                    localStorage.removeItem('mesa');
							this.order_finish = true;
						}
						if (data_json.data.id_type_status==93) {
							self.orderCanceled();
							localStorage.removeItem('id_order');
		                    localStorage.removeItem('id_punto');
		                    localStorage.removeItem('mesa');
							this.order_finish = true;
							this.show_ref = false;
							this.order_explote = true;
						}
						if (this.$route.params.mesa > 0) {
						 localStorage.setItem(`id_estado_order_${localStorage.getItem('companie_id')}_${this.$route.params.mesa}`,data_json.data.id_type_status);
						}else{
						 localStorage.setItem(`id_estado_order_${localStorage.getItem('companie_id')}`,data_json.data.id_type_status);
						}
						self.getOrderTracking(data_json.data.id_order);
		  			});
	        }
		},
		created(){
			//this.socket = io(`https://back.vinapp.co:3002`,{transports: ['websocket'], upgrade: false})
			//this.socket = io(`https://back.vinapp.co:3000`,{transports: ['websocket'], upgrade: false})
		},		
		mounted(){
			if (!this.formRestaurant) {
				$(".force-close").addClass("pt");
			}else{
				$(".force-close").removeClass("pt");
			}
			if (this.$route.params.mesa > 0) {
				this.socketInfo.id_type_status = localStorage.getItem(`id_estado_order_${localStorage.getItem('companie_id')}_${this.$route.params.mesa}`);
			}else{
				this.socketInfo.id_type_status = localStorage.getItem(`id_estado_order_${localStorage.getItem('companie_id')}`);
			}
			
			//this.socket = io(`https://back.vinapp.co:3002`,{transports: ['websocket'], upgrade: false})
			if ('Notification' in window) {
  				Notification.requestPermission();
			}
			//this.showNotification("Llegó una orden", "Nueva orden");
			var date = new Date();
			var menor = "";
			if(date.getMinutes() < 10){
				menor = "0" + date.getMinutes();
			}else{
				menor = date.getMinutes();
			}
			this.horaNueva = date.getHours() + ":" + menor;
			$(".status-task i:nth-child(3)").hide();
			$(".body-real-time .first-task .status-task i:nth-child(2)").hide();
			$(".body-real-time .first-task .status-task").addClass("animation");
			//this.id_order=localStorage.getItem('id_order');
			//this.id_point=localStorage.getItem('id_punto');
			//this.id_tracking=localStorage.getItem('id_estado_order');
			var self = this;

	      	//this.socket = io(`https://back.vinapp.co:3002`,{transports: ['websocket'], upgrade: false})
	      	this.socket = io(`https://back.vinapp.co:3000`,{transports: ['websocket'], upgrade: false})
		    console.log('Conectado')
			self.getOrderTracking(self.id_order,true);
            
            //this.emitSocketTable(this.id_point);
			this.setupSocket()
			this.hideClock();
		}
	}
</script>




